<template>
	<div class="view">
		<ArticleContainer>
			<header class="section">
				<div class="left">
					<div class="title">Тату-культура</div>
					<div
						class="text light"
					>Главный участник тату-конвенции и платформы Made For Олег Турянский начал заниматься татуировкой шестнадцать лет назад. В те времена, когда индустрия еще только зарождалась, мало кто понимал, к чему все это приведет. Сейчас наш герой — один из ведущих мастеров Москвы. Он поделился с нами богатым опытом и рассказал «Ленте.ру» о тату-трендах, терпении и выносе мозга.
						<div class="line"></div>
					</div>
				</div>
				<div class="right"></div>
			</header>

			<div class="section qoute">
				<div class="inner">
					<uiDevider/>
					<div
						class="quote-text"
					>Сейчас наш герой — один из ведущих мастеров Москвы. Он поделился с нами богатым опытом и рассказал «Ленте» о тату-трендах, терпении и выносе мозга.</div>
					<uiDevider/>
				</div>
			</div>

			<div class="section one">
				<div class="inner">
					<div class="left">
						<img src="@/assets/article1/2.jpg">
					</div>
					<div class="right">
						<div class="subtitle">Коллаборация с Made For</div>
						<div
							class="text light"
						>Татуировки сегодня — это часть массовой визуальной культуры: их можно увидеть у человека любого пола, профессии и мировоззрения. Даже бренд американского виски выпустил свою татуированную бутылку — именно так родилась моя коллаборация с платформой Made For в России. Совместить бурбон с татуировкой — задача сложная, но интересная. Кукуруза, рожь, солод и ячмень — довольно оригинальные составляющие для вдохновения, согласитесь.</div>
						<div
							class="text dark"
						>В рамках этой платформы состоится серия мероприятий, в том числе тату-конвенция. Чтобы попасть на нее, мы объявляем конкурс. Условия просты: нужно рассказать свою уникальную историю. Но важно помнить — рассказ должен не только удивить, но и бросить вызов.</div>
					</div>
				</div>
			</div>

			<div class="section two">
				<div class="inner">
					<div class="subtitle">О культуре татуировки</div>
					<div
						class="text light"
					>Когда я начинал, во всей Москве была пара полуподвальных магазинов с оборудованием и четыре студии. Сейчас у нас в городе более полутора тысяч студий — так индустрия развилась за шестнадцать-восемнадцать лет. Многие тогда били самопальными машинками. Я сам видел, например, как один парень заводил машинку ключиком. Цикл работы — минута. Потом он снова ее заводил. Никакого провода, никакого блока питания. Иглы напаивали на штангу тоже самостоятельно.
						<br>
						<br>Первые мастера, которые ездили на конвенции за границу, знаниями делились неохотно. Я приходил к ним, смотрел и учился. На освоение материала у меня ушло пять лет.
					</div>
					<div class="bottom">
						<div class="left">
							<div class="subtitle">О конкуренции</div>
							<div
								class="text light"
							>Конкуренция растет. Если кто-то хочет сделать у меня портрет, а я не могу принять, то человек просто пойдет к другому мастеру. У меня всегда был лист ожидания на полтора месяца вперед. В 2016 году на пару лет я уехал работать в Штаты, в Массачусетс. А когда вернулся, понял, что растерял наработанную базу. Восстанавливал ее целый год. В этот период у меня были перебои с работой. В общем, если ты нормально работаешь, то всегда будешь при деле.</div>
						</div>
						<div class="right">
							<img src="@/assets/article1/3.jpg">
						</div>
					</div>
				</div>
			</div>

			<div class="section three"></div>

			<div class="section four">
				<div class="inner">
					<div
						class="text dark big"
					>Я сам видел, например, как один парень заводил машинку ключиком. Цикл работы — минута. Потом он снова ее заводил. Никакого провода, никакого блока питания. Иглы напаивали на штангу тоже самостоятельно.</div>
					<img src="@/assets/article1/5.jpg">
				</div>
			</div>

			<div class="section one">
				<div class="inner">
					<div class="left">
						<img src="@/assets/article1/6.jpg">
					</div>
					<div class="right">
						<div class="subtitle">О западных ценностях и вкусах</div>
						<div
							class="text light"
						>У меня всегда были стереотипные представления об Америке. Что люди там более открытые, демократичные и не такие мозгокруты, как у нас. Так все и оказалось. В России люди очень подозрительные, до всего докапываются. В Штатах — наоборот: ты чувствуешь, что тебе доверяют, и от этого работа получается лучше. Американцы полностью отдаются в руки мастера, потому что знают: раз у него есть лицензия, есть портфолио, то он не подведет. Но если ты работаешь с контрол-фриком, то и стараться не хочется. Сделать так, как должен, или так, как могу, — это разные вещи.</div>
					</div>
				</div>
			</div>

			<div class="section five">
				<div class="inner">
					<div
						class="text light"
					>Американцы часто набивают животных. Как в России, например, есть тотемные (медведь, волк, тигр), так и в Америке очень популярны орлы, индейские темы. Одно время, правда, были популярны русские тюремные татуировки. Сам не колол, но видел и слышал разговоры об этом. Там это суперэкзотика. Как для нас какие-то японские узоры, где каждый листок, каждый завиток, каждый цвет что-то значит.</div>

					<img src="@/assets/devider2.png">
					<div
						class="text dark big"
					>Помню, на одной из конвенций ко мне подходит большой черный парень, показывает мне на телефоне купола и говорит: «Чувак, я вот такое себе хочу!» Сначала я подумал, что он стебется, но он был абсолютно серьезен.</div>
					<img src="@/assets/devider2.png">
				</div>
			</div>
		</ArticleContainer>
	</div>
</template>

<script>
import ArticleContainer from '@/components/ArticleContainer'

export default {
	components: {
		ArticleContainer
	},
}
</script>



<style lang="less" scoped>
@import "../styles.less";

.view {
	width: 100vw;
	height: 100vh;
	@media (max-width: 900px) {
		height: auto;
	}
}

.section {
	background: @color-main;
	color: #000;
}

.text {
	font-size: 16px;
	max-width: 500px;
	text-align: left;

	&.light {
		color: #fff;
	}

	&.dark {
		font-family: @font-title;
		font-size: 20px;
		font-weight: bold;
		line-height: 26px;
		text-transform: uppercase;
	}

	&.dark.big {
		font-size: 30px;
		line-height: 36px;
		text-transform: none;
	}
}

.subtitle {
	font-size: 20px;
	margin-bottom: 15px;
	text-align: left;
	font-weight: bold;
}

header {
	/deep/ .fp-tableCell {
		display: flex;
	}

	.left {
		width: 55vw;
		height: 100vh;
		background: @color-main;
		color: #000;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		.title {
			width: 100%;
			max-width: 500px;
			font-size: 60px;
			font-weight: bold;
			margin-bottom: 30px;
			text-transform: uppercase;
			font-family: @font-title;
			text-align: left;
		}

		.text {
			line-height: 30px;
			font-size: 18px;
		}

		.line {
			width: 2px;
			height: 50px;
			background: #fff;
			margin-top: 20px;
			transform-origin: top;
			animation: bounceAnim 1.2s linear infinite;
		}
	}

	.right {
		width: 45vw;
		height: 100vh;
		background-image: url("../assets/article1/1.jpg");
		background-size: cover;
		background-position: center;
	}

	@keyframes bounceAnim {
		0%,
		100% {
			transform: scaleY(0.8);
		}
		50% {
			transform: scaleY(1);
		}
	}

	@media (max-width: 900px) {
		display: flex;
		flex-direction: column-reverse;

		.left {
			width: 100vw;
			max-width: 90%;
			height: auto;
			margin: 0 auto;

			.title {
				font-size: 30px;
				padding-top: 30px;
				margin-bottom: 20px;
			}

			.line {
				display: none;
			}
		}

		.right {
			width: 100vw;
			height: 60vh;
		}
	}
}

.qoute {
	.inner {
		width: 100%;
		max-width: 800px;
		margin: 0 auto;
	}
	.quote-text {
		text-align: center;
		font-size: 50px;
		font-family: @font-title;
		font-weight: bold;
		line-height: 48px;
		margin: 40px 0;
	}

	@media (max-width: 900px) {
		.inner {
			padding-top: 30px;
			padding-bottom: 30px;
		}

		.quote-text {
			width: 90%;
			margin: 30px auto;
			font-size: 36px;
			line-height: 40px;
		}
	}
}

.section.one {
	.inner {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}

	.text {
		margin-bottom: 30px;
	}

	.left {
		margin-right: 60px;
	}

	@media (max-width: 900px) {
		.inner {
			flex-direction: column;
			width: 90%;
			margin: 0 auto;
		}

		.left {
			margin: 0;
			margin-bottom: 30px;

			img {
				width: 100%;
			}
		}
	}
}

.section.two {
	.inner {
		margin: 0 auto;
		max-width: 900px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.subtitle {
		width: 100%;
		text-align: left;
	}

	.text {
		max-width: 100%;
	}

	.bottom {
		display: flex;
		margin-top: 50px;

		.right {
			margin-left: 50px;
		}
	}

	@media (max-width: 900px) {
		.inner {
			flex-direction: column;
			width: 90%;
			margin: 0 auto;
		}

		.bottom {
			flex-direction: column-reverse;
			margin: 30px 0;

			.right {
				margin: 0;
				margin-bottom: 30px;
				img {
					width: 100%;
				}
			}
		}
	}
}

.section.three {
	background-size: cover;
	background-image: url(../assets/article1/4.jpg);

	@media (max-width: 900px) {
		width: 100vw;
		height: 60vh;
		background-position: center;
	}
}

.section.four {
	.inner {
		max-width: 1000px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto;
	}

	img {
		margin-left: 50px;
		max-width: 50%;
	}

	@media (max-width: 900px) {
		.inner {
			width: 90%;
			margin: 0px auto;
			padding: 30px 0;
			flex-direction: column;
		}

		.text {
			font-size: 24px;
			line-height: 30px;
		}

		img {
			width: 100%;
			margin: 0;
			margin-top: 30px;
		}
	}
}

.section.five {
	.inner {
		margin: 0 auto;
		max-width: 780px;
	}

	.text {
		max-width: 100%;
		text-align: center;
	}

	.text.light {
		margin-bottom: 50px;
	}

	img {
		margin: 30px auto;
	}

	@media (max-width: 900px) {
		.inner {
			width: 90%;
			margin: 0px auto;
			padding: 30px 0;
			flex-direction: column;
		}
	}
}
</style>
